// This file is auto-generated from version.json
// Do not edit this file directly, update version.json instead

import versionData from "../version.json";

export const APP_VERSION = versionData.version;
export const BUILD_DATE = versionData.buildDate;

export default {
  version: APP_VERSION,
  buildDate: BUILD_DATE,
};
